import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../../shared/providers/base-provider';
import { BookmarkNotifier } from './bookmark-notifier';
import { BookmarkState } from './bookmark-state';

@Injectable()
export class BookmarkProvider extends BaseProvider<BookmarkNotifier, BookmarkState> {
  constructor() {
    super(BookmarkNotifier);
    this.trackSessionReset(() => this.notifier.resetState());
  }
}
